import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { loginAction } from "../../redux/actions/authAction";
import { useDispatch } from "react-redux";
import { errorToast, successToast } from "../../components/notifications/toast";
import { setFavicon } from "../../components/helper";
import LoaderModal from "../../components/modals/loader-modal";
import logo from "../../assets/logos/logo.png"
import { viewSettingsAction } from "../../redux/actions/settingsAction";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const initialValues = {
        email: "",
        password: "",
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
    });

    const handleSubmit = (values, { setSubmitting }) => {
        console.log("Login Form Submitted", values);
        setLoading(true)
        dispatch(loginAction(values, onLoginSuccess, onError))
        setSubmitting(false)
    };

    const onLoginSuccess = (data) => {
        setLoading(false)
        successToast(data.data.message)
        if (data.data.data.accessToken) {
            localStorage.setItem('accessToken', data.data.data.accessToken);
            localStorage.setItem('userId', data.data.data?.user?.id);
            if (data.data.data?.company) {
                localStorage.setItem('company_name', data.data.data?.company?.name);
                if (data.data.data?.company?.logo) {
                    localStorage.setItem('company_logo', data.data.data?.company?.logo);
                    setFavicon(data.data.data?.company?.logo)
                }
            }
            dispatch(viewSettingsAction({}, (data) => { }, onError))
            navigate('/dashboard');
        }
    }

    const onError = (data) => {
        setLoading(false)
        const errorMsg = data.data.message || "Unable to login try later";
        errorToast(errorMsg)
    }

    return (
        <div className="min-h-screen flex items-center bg-gray-100">

            <div
                className="hidden lg:block w-1/2 bg-cover bg-center min-h-svh"
                style={{
                    backgroundImage: 'url(/logo3.webp)', //this should be inside public
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >

            </div>

            <div className="w-full lg:w-1/2 flex justify-center items-center mx-2">
                <div className="w-full max-w-md bg-white p-6 rounded-md shadow-md relative">
                    <div className="absolute top-[-120px] left-0 right-0 text-center">
                        <h1
                            className="text-primary uppercase animate-slide-in text-6xl font-extrabold"
                            style={{
                                animation: "smoothFadeIn 2s ease-in-out forwards",
                                letterSpacing: "0.1em",
                            }}
                        >
                            Invetix
                        </h1>
                    </div>

                    {/* Login Card */}
                    <div className="flex justify-center items-center gap-4">
                        <img
                            src={logo}
                            alt="Company Logo"
                            className="object-cover rounded"
                            style={{ height: "50px", width: "50px" }}
                        />
                        <h2 className="text-2xl font-bold text-center text-primary">Login</h2>
                    </div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form className="mt-4">
                                <div className="mb-4">
                                    <label className="block text-sm text-start font-medium text-gray-600">
                                        Email
                                    </label>
                                    <Field
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        className="w-full px-4 py-2 mt-2 input-field"
                                    />
                                    <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="text-sm text-start text-red-500 mt-1"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label className="block text-sm text-start font-medium text-gray-600">
                                        Password
                                    </label>
                                    <Field
                                        type="password"
                                        name="password"
                                        placeholder="Enter your password"
                                        className="w-full px-4 py-2 mt-2 input-field"
                                    />
                                    <ErrorMessage
                                        name="password"
                                        component="div"
                                        className="text-sm text-start text-red-500 mt-1"
                                    />
                                </div>

                                <div className="mt-6">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full px-4 py-2 text-white bg-blue-700 rounded-md hover:bg-blue-600 focus:outline-none"
                                    >
                                        {isSubmitting ? "Logging in..." : "Login"}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            {loading &&
                <LoaderModal />
            }

        </div>
    );
};

export default Login;
